import React from "react";

//
//
import AnimationBanner from "../components/AnimationBanner/AnimationBanner";
import Furniture from "../components/ChairScene/index";
import PropHeaderSections from "../components/PropHeaderSections/PropHeaderSections";
import SavoirFaire from "../components/SavoirFaire/SavoirFaire";
import HomeScreen from "../screens/HomeScreen";
//
//

//
//
const Home = () => {
  return (
    <>
      <div id="wrapper-app">
        <div className="container_app">
          <Furniture />
          <PropHeaderSections
            TitlePropHeaderSection="new arrivals"
            SubTitlePropHeaderSection="explore"
          />
          <AnimationBanner />
          <PropHeaderSections
            TitlePropHeaderSection="back in stock"
            SubTitlePropHeaderSection="shop now"
          />
          <HomeScreen />
          <PropHeaderSections
            TitlePropHeaderSection="the collection"
            SubTitlePropHeaderSection="view all"
          />
          <SavoirFaire />
        </div>
      </div>
    </>
  );
};

export default Home;
